const required = value => (value ? undefined : "Pole wymagane");

const requiredCustom = text => value => (value ? undefined : text);

const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Adres email nieprawidłowy"
    : undefined;

const maxLengthPassword = max => value =>
  value && value.length > max
    ? `Hasło musi mieć mniej niż ${max} znaków`
    : undefined;

const minLengthPassword = min => value =>
  value && value.length < min
    ? `Hasło nie może być krótsze niż ${min} znaków`
    : undefined;

export {
  required,
  requiredCustom,
  email,
  minLengthPassword,
  maxLengthPassword
};



// WEBPACK FOOTER //
// ./src/lib/validation.js